import noUiSlider from 'nouislider';

class Sliders {
	constructor(config) {
		this.config = Object.assign({
			scope: '.range-slider'
		}, config)

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((it, scope) => {
			let $scope = $(scope);
			let min = this.getNumber($scope.data('min'));
			let currentMin = this.getNumber($scope.data('current-min'));
			let max = this.getNumber($scope.data('max'));
			let currentMax = this.getNumber($scope.data('current-max'));

			let slider = noUiSlider.create(scope, {
				start: [currentMin, currentMax],
				connect: true,
				range: {
					'min': min,
					'max': max
				}
			});

			slider.on('update', values => {
				this.sliderUpdated(values, $scope);
			});

			slider.on('end', values => {
				let $parent = $scope.parent();
				let $minInput = $parent.find('.item-min');
				$minInput.trigger('change');
			});
		});
	}

	sliderUpdated(values, $scope) {
		let $parent = $scope.parent();
		let min = Math.round(values[0]);
		let max = Math.round(values[1]);

		let $minInput = $parent.find('.item-min');
		let $maxInput = $parent.find('.item-max');

		$minInput.val(min);
		$parent.find('.label-min').html(min);

		$maxInput.val(max);
		$parent.find('.label-max').html(max);
	}

	changeLabelPositions(slider, $scope) {
		let $parent = $scope.parent();
		let positions = slider.getPositions();
		let $min = $parent.find('.label-min');
		let $max = $parent.find('.label-max');
		let handleWidth = $scope.find('.noUi-handle').outerWidth();

		if (positions[0] >= 5) {
			$min.css('left', `${positions[0]}%`);
			$min.css('transform', `translateX(-50%)`);
		} else {
			$min.css('left', `-${handleWidth * .5}px`);
			$min.css('transform', `translateX(0)`);
		}

		if (positions[1] < 95) {
			$max.css('right', `${100 - positions[1]}%`);
			$max.css('transform', `translateX(50%)`);
		} else {
			$max.css('right', `-${handleWidth * .5}px`);
			$max.css('transform', `translateX(0)`);
		}
	}

	getNumber(number) {
		number = parseFloat(number);
		return isNaN(number) ? 0 : number;
	}
}

export default Sliders;